import { Theme, makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme: Theme) => ({
  mapContainer: {
    direction: 'ltr',
    width: '100%',
    height: '100%',
    zIndex: 0,
    '& .leaflet-control-attribution a': {
      display: 'none',
    },
  },
  popup: {
    direction: theme.direction,
    '& .leaflet-popup-content-wrapper, .leaflet-popup-tip': {
      background: '#000000c4 !important',
    },
    '& .leaflet-popup-content p': {
      margin: 0,
    },
    '& .leaflet-popup-content': {
      minWidth: '175px !important',
      margin: '15px 10px 0 10px',
    },
  },
}))
